import { render, staticRenderFns } from "./SAPRateEditButton.vue?vue&type=template&id=63b72544"
import script from "./SAPRateEditButton.vue?vue&type=script&lang=js"
export * from "./SAPRateEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports